export default __webpack_public_path__ + "static/media/ibrahiShamsiAbout.7f2e805b.png";